import React from 'react'
import styled from 'styled-components'
import { line, radius, shadow, font } from 'features/dashboard/tokens'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

const ROWS = [
  { keys: ['?'],           label: 'Open this help' },
  { keys: ['/'],           label: 'Focus search' },
  { keys: ['g', 'd'],      label: 'Go to dashboard' },
  { keys: ['1'],           label: 'View to-do today' },
  { keys: ['2'],           label: 'View Building Passports' },
  { keys: ['3'],           label: 'View Trends' },
  { keys: ['w'],           label: 'Open guided fix wizard' },
  { keys: ['b'],           label: 'Open bulk override wizard' },
  { keys: ['j'],           label: 'Jump to any portfolio, estate, building or unit' },
  { keys: ['Esc'],         label: 'Close any modal' },
]

const ShortcutHelp = ({ open, onClose }) => {
  if (!open) return null
  return (
    <Backdrop onClick={onClose}>
      <Card onClick={e => e.stopPropagation()}>
        <CloseBtn onClick={onClose}><CloseRoundedIcon style={{ fontSize: 18 }} /></CloseBtn>
        <Eyebrow>Keyboard</Eyebrow>
        <Title>Shortcuts</Title>
        <Subtitle>Press these from anywhere on the dashboard. Inputs are ignored.</Subtitle>
        <Table>
          {ROWS.map(({ keys, label }) => (
            <Row key={label}>
              <Keys>
                {keys.map((k, i) => (
                  <React.Fragment key={k}>
                    <Kbd>{k}</Kbd>
                    {i < keys.length - 1 && <Then>then</Then>}
                  </React.Fragment>
                ))}
              </Keys>
              <Label>{label}</Label>
            </Row>
          ))}
        </Table>
      </Card>
    </Backdrop>
  )
}

export default ShortcutHelp

const Backdrop = styled.div`
  position: fixed; inset: 0;
  background: rgba(12, 18, 41, 0.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 1400; padding: 24px;
`

const Card = styled.div`
  position: relative;
  width: 100%; max-width: 480px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${radius.md};
  padding: 28px 32px 24px;
  box-shadow: ${shadow.overlay};
`

const CloseBtn = styled.button`
  position: absolute; top: 14px; right: 14px;
  display: inline-flex; align-items: center; justify-content: center;
  width: 32px; height: 32px;
  background: rgba(12,18,41,0.06);
  border: none; border-radius: ${radius.round};
  cursor: pointer; color: ${({ theme }) => theme.colors.haiti};
  &:hover { background: rgba(12,18,41,0.14); }
`

const Eyebrow = styled.div`
  font-size: ${font.caption};
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.grey[800]};
  font-weight: 800;
  margin-bottom: 4px;
`

const Title = styled.h2`
  margin: 0 0 6px;
  font-family: 'FuturaPT-Light', system-ui, sans-serif;
  font-size: ${font.display};
  letter-spacing: -0.6px;
  color: ${({ theme }) => theme.colors.haiti};
`

const Subtitle = styled.p`
  margin: 0 0 18px;
  font-size: ${font.body};
  color: ${({ theme }) => theme.colors.grey[800]};
`

const Table = styled.div`
  display: flex; flex-direction: column;
`

const Row = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid ${line.base};
  &:last-child { border-bottom: none; }
`

const Keys = styled.div`
  display: inline-flex; align-items: center; gap: 6px;
`

const Kbd = styled.kbd`
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 26px; height: 26px;
  padding: 0 8px;
  background: ${({ theme }) => theme.colors.lighterGrey};
  border: 1px solid ${line.strong};
  border-bottom-width: 2px;
  border-radius: ${radius.sm};
  font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: ${font.caption};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.haiti};
`

const Then = styled.span`
  font-size: ${font.caption};
  font-style: italic;
  color: ${({ theme }) => theme.colors.grey[800]};
`

const Label = styled.span`
  font-size: ${font.body};
  color: ${({ theme }) => theme.colors.haiti};
`
